import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import { motion } from 'framer-motion';

const Contact: React.FC = () => {
  return (
    <Box id="contact" sx={{ py: { xs: 6, md: 12 }, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          sx={{
            mb: 6,
            fontWeight: 600,
            fontSize: { xs: '2rem', md: '2.5rem' },
          }}
        >
          <Box
            component="a"
            href="mailto:office@abarcar.com.au"
            sx={{
              color: 'secondary.main',
              textDecoration: 'none',
              '&:hover': {
                color: 'primary.main',
              },
            }}
          >
            Get in Touch
          </Box>
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  backgroundColor: 'background.paper',
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    mb: 3,
                    fontWeight: 600,
                    color: 'primary.main',
                  }}
                >
                  Contact Information
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: 'text.primary',
                    }}
                  >
                    Email
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    <Box
                      component="a"
                      href="mailto:office@abarcar.com.au"
                      sx={{
                        color: 'text.secondary',
                        textDecoration: 'none',
                      }}
                    >
                      office@abarcar.com.au
                    </Box>
                  </Typography>
                </Box>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: 'text.primary',
                    }}
                  >
                    Phone
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    +61433379280
                  </Typography>
                </Box>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: 'text.primary',
                    }}
                  >
                    ABN
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    12 669 688 957
                  </Typography>
                </Box>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: 'text.primary',
                    }}
                  >
                    Brisbane Office
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    Level 14, 167 Eagle Street, Brisbane QLD 4000
                  </Typography>
                </Box>
                {/*<Box>*/}
                {/*  <Typography*/}
                {/*      variant="subtitle1"*/}
                {/*      sx={{*/}
                {/*          mb: 1,*/}
                {/*          fontWeight: 600,*/}
                {/*          color: 'text.primary',*/}
                {/*      }}*/}
                {/*  >*/}
                {/*      Hong Kong Office*/}
                {/*  </Typography>*/}
                {/*  <Typography*/}
                {/*      variant="body1"*/}
                {/*      sx={{*/}
                {/*          color: 'text.secondary',*/}
                {/*      }}*/}
                {/*  >*/}
                {/*      1707, 17/F, 463-483 Lockhart Road, Causeway Bay, Hong Kong*/}
                {/*  </Typography>*/}
                {/*</Box>*/}
              </Paper>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  backgroundColor: 'background.paper',
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    mb: 3,
                    fontWeight: 600,
                    color: 'primary.main',
                  }}
                >
                  Office Hours
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: 'text.primary',
                    }}
                  >
                    Monday - Friday
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    9:00 AM - 5:00 PM
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: 'text.primary',
                    }}
                  >
                    Saturday - Sunday
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    Closed
                  </Typography>
                </Box>
              </Paper>
            </motion.div>
          </Grid>
        </Grid>
        <Box sx={{ mt: 6 }}>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3540.1050248507813!2d153.02569872812768!3d-27.465989515082605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b915bad7b92ae73%3A0x4e0cf88a66635f52!2s167%20Eagle%20St%2C%20Brisbane%20City%20QLD%204000!5e0!3m2!1sen!2sau!4v1748220460218!5m2!1sen!2sau"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
          />
        </Box>

        {/*<Box sx={{mt: 6}}>*/}
        {/*    <iframe*/}
        {/*        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.934924996571!2d114.17951671247349!3d22.28045477961625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3404005718a32ebf%3A0x45058d732b33247a!2sLippo%20House%20(causeway%20Bay%20Plaza%202)%2C%20463-483%20Lockhart%20Rd%2C%20Bowrington%2C%20Hong%20Kong!5e0!3m2!1sen!2sau!4v1748220390749!5m2!1sen!2sau"*/}
        {/*        width="100%"*/}
        {/*        height="450"*/}
        {/*        style={{ border: 0, borderRadius: '8px' }}*/}
        {/*        allowFullScreen*/}
        {/*        loading="lazy"*/}
        {/*        referrerPolicy="no-referrer-when-downgrade"*/}
        {/*    />*/}
        {/*</Box>*/}

      </Container>
    </Box>
  );
};

export default Contact; 